import CommentContainer from './CommentContainer';
import React from 'react';
import agent from '../../agent';
import { connect } from 'react-redux';
import marked from 'marked';
import { BLOG_PAGE_LOADED, BLOG_PAGE_UNLOADED } from '../../constants/actionTypes';
import { Link } from 'react-router-dom';
import { checkboxToText } from '../../constants/colors';

import {
  MDBCard,
  MDBCardImage, MDBCol,
  MDBIcon, MDBBadge, MDBContainer,
  MDBCardHeader, MDBMedia
} from 'mdbreact';
import { Helmet } from "react-helmet";

require('react-quill/dist/quill.snow.css');

const mapStateToProps = state => ({
  ...state.blog,
  currentUser: state.common.currentUser
});

const mapDispatchToProps = dispatch => ({
  onLoad: payload =>
    dispatch({ type: BLOG_PAGE_LOADED, payload }),
  onUnload: () =>
    dispatch({ type: BLOG_PAGE_UNLOADED })
});

class Blog extends React.Component {
  componentWillMount() {
    this.props.onLoad(Promise.all([
      agent.Blogs.get(this.props.match.params.id),
      agent.Comments.forBlog(this.props.match.params.id)
    ]));
  }

  componentWillUnmount() {
    this.props.onUnload();
  }

  render() {
    if (!this.props.blog) {
      return null;
    }

    this.props.blog.body = this.props.blog.body.replace("img", 'img data-test="card-image" class="card-img-top"')
    var ele = document.createElement("div");
    ele.innerHTML = this.props.blog.body;
    var image = ele.querySelector("img");
    this.props.blog.body = image ? this.props.blog.body.replace(image.src, '') : this.props.blog.body;
    this.props.blog.body = this.props.blog.body.replace(/&nbsp;/g, ' ');

    const markup = { __html: marked(this.props.blog.body, { sanitize: false }) };

    const canModify = this.props.currentUser &&
      this.props.currentUser.username === this.props.blog.author.username;

    const isSoundExists = !(!this.props.blog.soundId || /^\s*$/.test(this.props.blog.soundId));

    return (
      <div style={{ textAlign: "center" }}>

        <Helmet>
          <meta charset='UTF-8' />
          <link rel='profile' href='http://gmpg.org/xfn/11' />
          <title>{this.props.blog.title}</title>
          <meta name="description" content={this.props.blog.description} />
          <meta name="robots" content="follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large" />
          <meta property="og:locale" content="ar_AR" />
          <meta property="og:type" content="article" />
          <meta property="og:title" content={this.props.blog.title} />
          <meta property="og:description" content={this.props.blog.description} />
          <meta property="og:url" content={window.location.href} />
          <meta property="og:site_name" content="طفلي" />
          {
            this.props.blog.tagList.map(tag => {
              return (
                <meta property="article:tag" content={checkboxToText[tag] ? checkboxToText[tag] : tag} />
              )
            })
          }
          <meta property="article:section" content="مقال" />
          <meta property="article:published_time" content={this.props.blog.createdAt} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={this.props.blog.title} />
          <meta name="twitter:description" content={this.props.blog.description} />
          {/* <script type="application/ld+json">
            {"@context":"https:\/\/schema.org",
            "@graph":[{"@type":"BlogPosting",
            "headline":"عنوان المقال",
            "datePublished":"تاريخ النشر",
            "publisher":{"@type":"Organization",
            "name":"اسم الموقع",
            "logo":{"@type":"ImageObject","url":"رابط اللوغو"}},
            "mainEntityOfPage":{"@type":"WebPage","@id":"رابط المقال"},
            "author":{"@type":"Person","name":"اسم الكاتب"},
            "description":"الوصف المفتاحي للمقال","image":{"@type":"ImageObject","url":"رابط صورة المقال","width":600,"height":608}}]}
          </script> */}
          <link rel='dns-prefetch' href='//fonts.googleapis.com' />
          <link href='https://fonts.gstatic.com' crossorigin rel='preconnect' />
        </Helmet>

        <MDBCard style={{
          marginTop: "20px",
          marginRight: "20px",
          marginLeft: "20px",
          marginBottom: "20px",
          maxWidth: "80%",
          minWidth: "80%",
          display: "inline-block",
        }} dir="rtl">

          <MDBCardImage
            hover
            overlay='white-light'
            className='card-img-top'
            src={this.props.blog.blogImage ? this.props.blog.blogImage : require('../../static/blog_img_placeholder01.jpg')}
            alt='man'

          />
          <MDBContainer>

            <MDBCol md='12' className='d-flex justify-content-center' style={{ paddingTop: "10px" }}>
              {
                this.props.blog.tagList.map(tag => {
                  return (
                    <MDBBadge pill color="danger-color-dark" style={{ marginLeft: "10px" }}>
                      {checkboxToText[tag] ? checkboxToText[tag] : tag}
                    </MDBBadge>
                  )
                })
              }
            </MDBCol>

            <h1 class="text-center h1 pt-4 mb-3">
              <strong>{this.props.blog.title}</strong>
            </h1>

            <div class="row">
              <div class="col-md-12 col-xl-12 d-flex justify-content-center">
                <p class="font-small grey-text mb-0 ml-3" style={{ textAlign: "center" }}>
                  {this.props.blog.description}
                </p>
              </div>
            </div>

            {isSoundExists ? (
              <div class="row" style={{ paddingTop: "1rem" }}>
                <div class="col-md-12 col-xl-12 d-flex justify-content-center">
                  <iframe width="100%" height="150" scrolling="no" frameborder="no" allow="autoplay"
                    src={"https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/" + this.props.blog.soundId + "&amp;color=%23ff5500&amp;auto_play=false&amp;hide_related=true&amp;show_comments=false&amp;show_user=false&amp;show_reposts=false&amp;show_teaser=false&amp;visual=false&amp;show_artwork=false&amp;download=false&amp;sharing=false&amp;buying=false&amp;liking=false"}>
                  </iframe>
                  <div style={{
                    display: "none", fontSize: "10px", color: "#cccccc", lineBreak: "anywhere", wordBreak: "normal", overflow: "hidden",
                    whiteSpace: "nowrap", textOverflow: "ellipsis", fontFamily: "Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif",
                    fontWeight: "100"
                  }}>
                    <a href="https://soundcloud.com/user-456545959" title="منصة طفلي" target="_blank"
                      style={{ color: "#cccccc", textDecoration: "none" }}>منصة طفلي</a> · <a href="https://soundcloud.com/user-456545959" title="منصة طفلي" target="_blank"
                        style={{ color: "#cccccc", textDecoration: "none" }}>منصة طفلي</a>
                  </div>
                </div>
              </div>
            ) : null}

          </MDBContainer>

          <MDBContainer style={{ paddingTop: "100px" }}>
            <div class="ql-editor" dangerouslySetInnerHTML={markup}>
            </div>
          </MDBContainer>

          {/* Author View */}
          <MDBContainer style={{ paddingTop: "100px" }}>
            <MDBCardHeader className="border-0 font-weight-bold d-flex justify-content-between" >
              <p className="mb-0">عن الكاتب</p>
              <ul className="list-unstyled list-inline mb-0">

                {canModify ?
                  <Link to={`/editor/${this.props.blog.slug}`} style={{ display: "inline" }}>
                    <li className="list-inline-item mr-3">تعديل<MDBIcon className="mr-2" icon="edit" /></li>
                  </Link> :
                  null}

                <li className="list-inline-item mr-3">ملف الكاتب<MDBIcon className="mr-2" icon="user" /></li>
                <li className="list-inline-item mr-3">تابع الكاتب<MDBIcon className="mr-2" icon="rss" /></li>
              </ul>
            </MDBCardHeader>
            <MDBMedia className="p-4 bg-white">
              <MDBMedia >
                <img className="card-img-100 d-flex z-depth-1 mr-3" src={this.props.blog.author.image} alt="" />
              </MDBMedia>
              <MDBMedia body style={{ textAlign: "right", marginRight: "15px" }}>
                <h5 className="font-weight-bold mt-0">
                  {this.props.blog.author.username}
                </h5>
                {this.props.blog.author.bio}
              </MDBMedia>
            </MDBMedia>
          </MDBContainer>

          <hr class="mt-5" />

          <MDBContainer>
            <CommentContainer
              comments={this.props.comments || []}
              errors={this.props.commentErrors}
              slug={this.props.match.params.id}
              currentUser={this.props.currentUser}
              authorizeCommentsBeforePublish={this.props.blog.authorizeCommentsBeforePublish}
            />
          </MDBContainer>

        </MDBCard>
      </div>

    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Blog);
